import React, {useEffect, useState} from 'react';
import {motion} from 'framer-motion';
import {pdfjs} from 'react-pdf';
import './PDFPreviewCard.css';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFPreviewCard = ({file, onOpen}) => {
    const [imageDataUrl, setImageDataUrl] = useState(null);

    useEffect(() => {
        const renderPageToImage = async () => {
            const loadingTask = pdfjs.getDocument(file);
            const pdf = await loadingTask.promise;
            const page = await pdf.getPage(1);
            const viewport = page.getViewport({scale: 2});
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            const renderContext = {
                canvasContext: context,
                viewport: viewport,
            };

            await page.render(renderContext).promise;
            setImageDataUrl(canvas.toDataURL());
        };

        renderPageToImage();
    }, [file]);

    return (
        <motion.div
            className="PDFPreviewCard"
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
            onClick={onOpen}
            transition={{
                type: "spring",
                stiffness: 400,
                damping: 10,
                duration: 0.2
            }}
        >
            {imageDataUrl ? (
                <img src={imageDataUrl} alt="PDF preview" width={300} height={400}/>
            ) : (
                <div>Загрузка...</div>
            )}
        </motion.div>
    );
};

export default PDFPreviewCard;